import React from 'react';
import { Archive, ArrowRight, CalendarOff } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Season, SeasonStatus } from '../types';

export const hasActiveSeason = (seasons: Season[]) =>
    seasons.some(season => season.status === SeasonStatus.PUBLISHED && season.is_active === true);

interface NoActiveSeasonProps {
    description?: string;
    compact?: boolean;
}

export const NoActiveSeason: React.FC<NoActiveSeasonProps> = ({
    description = 'Die letzte Saison ist beendet. Sobald die neue Saison veröffentlicht wird, erscheinen die aktuellen Daten wieder automatisch.',
    compact = false,
}) => (
    <section className={`relative overflow-hidden rounded-[2rem] border border-amber-300/15 bg-gradient-to-br from-amber-300/[0.08] via-[#12131a] to-[#0b0c11] ${compact ? 'p-5 md:p-6' : 'p-7 md:p-9'}`}>
        <div className="pointer-events-none absolute -right-12 -top-16 h-52 w-52 rounded-full bg-amber-300/10 blur-3xl" />
        <div className="relative flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
            <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border border-amber-200/15 bg-amber-300/10 text-amber-200">
                    <CalendarOff size={22} />
                </div>
                <div>
                    <p className="mb-1 text-[9px] font-black uppercase tracking-[0.28em] text-amber-200/60">Saisonpause</p>
                    <h2 className={`${compact ? 'text-xl' : 'text-2xl md:text-3xl'} font-black uppercase italic tracking-tight text-white`}>Keine laufende Saison</h2>
                    <p className="mt-2 max-w-2xl text-sm leading-6 text-white/45">{description}</p>
                </div>
            </div>
            <Link
                to="/history"
                className="inline-flex shrink-0 items-center justify-center gap-2 rounded-2xl border border-white/10 bg-white/[0.07] px-5 py-3 text-[10px] font-black uppercase tracking-[0.16em] text-white transition hover:border-amber-200/30 hover:bg-amber-200/10"
            >
                <Archive size={15} />
                Zur Historie
                <ArrowRight size={14} />
            </Link>
        </div>
    </section>
);
